import { render } from "./admin-club.vue?vue&type=template&id=1bd90280"
import script from "./admin-club.vue?vue&type=script&lang=js"
export * from "./admin-club.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-club.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bd90280"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bd90280', __exports__)) {
    api.reload('1bd90280', __exports__)
  }
  
  module.hot.accept("./admin-club.vue?vue&type=template&id=1bd90280", () => {
    api.rerender('1bd90280', render)
  })

}


export default __exports__